export default function SaveRumbleIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_622_738)'>
        <path
          d='M7.49967 13.5001L3.99967 10.0001L2.83301 11.1667L7.49967 15.8334L17.4997 5.83341L16.333 4.66675L7.49967 13.5001Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_622_738'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
